import { useFiltersContext } from "../contexts/FiltersContext";
import { useLockersContext } from "../contexts/LockersContext";
import { useEffect } from "react";

export const FiltersContainer = (): any => {
    const { filterStrategies, filtersChanged, setFilterCounter } = useFiltersContext();
    const { unfilteredLockerResponse, setLockerResponse } = useLockersContext();

    useEffect(() => {
        applyFilters();
    }, [unfilteredLockerResponse, filtersChanged])

    const applyFilters = (): void => {
        let lockersFiltered = unfilteredLockerResponse;
        let counter = 0;

        filterStrategies.filter(x => x.implementation.IsApplicable() === true).forEach(strategy => {
            lockersFiltered = strategy.implementation.Run(lockersFiltered)
            counter++;
        })

        setFilterCounter(counter)
        setLockerResponse(lockersFiltered);
    }

    return (
        <></>
    );
}

export default FiltersContainer